const projects = [
  {
    id: 1,
    title: "GoldStar Movers",
    category: "web",
    client: "GoldStar Movers Canada",
    image: "/images/portfolio/golstar-movers.png",
    tags: ["Next.js", "Node.js", "MySQL", "VPS"],
    description:
      "SEO-optimized moving and relocation website built for a Canadian logistics company to generate leads, showcase services, and improve online visibility.",
    fullDescription:
      "GoldStar Movers is a professional moving and relocation company serving customers across Canada. The platform was developed using Next.js, Node.js, and MySQL with a focus on performance, search engine optimization, and lead generation. The website features service-focused landing pages, quote request forms, mobile responsiveness, and a streamlined user experience designed to help potential customers quickly find moving solutions and submit inquiries.",
    features: [
      "Online quote requests",
      "SEO optimized pages",
      "Mobile responsive design",
      "Lead management",
    ],
    liveUrl: "https://goldstarmovers.ca/",
    githubUrl: "",
    duration: "1 Month",
    teamSize: "2 Developers",
  },

  {
    id: 2,
    title: "Powerlook",
    category: "ecommerce",
    client: "Powerlook India",
    image: "/images/portfolio/powerlook.png",
    tags: ["Next.js", "Node.js", "Ecommerce", "Payment Gateway"],
    description:
      "Modern fashion ecommerce platform built to deliver a fast, scalable, and conversion-focused shopping experience for customers across India.",
    fullDescription:
      "Powerlook is a rapidly growing fashion ecommerce brand serving customers throughout India. Developed using Next.js and Node.js, the platform provides a high-performance shopping experience with optimized product discovery, responsive design, secure checkout processes, and scalable architecture. The solution focuses on improving user engagement, product accessibility, and online sales performance while maintaining excellent page speed and usability.",
    features: [
      "Product catalog",
      "Secure payments",
      "Order management",
      "Mobile-first UI",
    ],
    liveUrl: "https://powerlook.in/",
    githubUrl: "",
    duration: "3 Months",
    teamSize: "3 Developers",
  },

  {
    id: 3,
    title: "Prometric Gulf",
    category: "web",
    client: "Prometric Gulf",
    image: "/images/portfolio/prometric.png",
    tags: ["Laravel", "MySQL", "Booking System", "SEO"],
    description:
      "Educational and examination information portal designed to help healthcare professionals prepare for licensing exams across GCC countries.",
    fullDescription:
      "Prometric Gulf provides valuable resources, exam guidance, and registration information for healthcare professionals preparing for licensing examinations in the Gulf region. Built using Laravel and MySQL, the platform delivers structured educational content, examination details, and user-friendly navigation. The website was designed with SEO best practices to improve visibility and help candidates easily access relevant exam information and preparation resources.",
    features: [
      "Exam information portal",
      "Online registration",
      "Content management",
      "SEO optimization",
    ],
    liveUrl: "https://prometricgulf.com/",
    githubUrl: "",
    duration: "2 Months",
    teamSize: "2 Developers",
  },

  {
    id: 4,
    title: "Blitznet",
    category: "marketplace",
    client: "Blitznet Indonesia",
    image: "/images/portfolio/blitznet.png",
    tags: ["Laravel", "B2B Marketplace", "MySQL", "REST API"],
    description:
      "Enterprise B2B marketplace platform connecting suppliers, distributors, and buyers through a centralized digital procurement ecosystem.",
    fullDescription:
      "Blitznet is a business-to-business marketplace developed to simplify supplier discovery and procurement processes for organizations across Indonesia. Built using Laravel and MySQL, the platform enables businesses to manage products, connect with verified suppliers, generate qualified leads, and streamline commercial transactions. The solution provides a scalable marketplace infrastructure designed to support business growth and operational efficiency.",
    features: [
      "Vendor management",
      "Product listings",
      "Lead generation",
      "Marketplace dashboard",
    ],
    liveUrl: "https://www.blitznet.co.id/",
    githubUrl: "",
    duration: "4 Months",
    teamSize: "4 Developers",
  },

  {
    id: 5,
    title: "UberFox",
    category: "saas",
    client: "UberFox USA",
    image: "/images/portfolio/uberfox.png",
    tags: ["Laravel", "Automation", "Lead Generation", "CRM"],
    description:
      "Lead generation and sales automation platform developed to help businesses streamline prospecting and customer acquisition workflows.",
    fullDescription:
      "UberFox is a SaaS-based automation platform focused on improving lead generation and sales efficiency. Developed using Laravel and MySQL, the system automates lead collection, prospect management, campaign tracking, and customer engagement processes. The platform helps businesses reduce manual work, improve conversion opportunities, and maintain a structured sales pipeline through intelligent workflow automation.",
    features: [
      "Lead automation",
      "CRM integration",
      "Campaign management",
      "Analytics dashboard",
    ],
    liveUrl: "https://uberfox.io/",
    githubUrl: "",
    duration: "5 Months",
    teamSize: "3 Developers",
  },
];

export default projects;
